export default "__VITE_ASSET__CPsGN3fp__"